import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import SplashCursor from './Animations/SplashCursor/SplashCursor.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <SplashCursor />
  </React.StrictMode>
);

reportWebVitals();
